/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { Button } from "@mui/material";
import React from "react";

const AccordionExpandCollapse = (props) => {

    const expandAllSections = props?.expandAllSections;
    const collapseAllSections = props?.collapseAllSections;
    const allClosed = props?.allClosed;
    const allOpen = props?.allOpen;

    return (
        <div className="acc-btn-wrapper">
            <Button
                variant="text"
                className={`acc-option ${allOpen ? "disabled" : "open"}`}
                onClick={allOpen ? null : expandAllSections}
                aria-label="Open all accordions in the next group"
            >
                Open all
            </Button>

            <span className="sep">|</span>

            <Button
                variant="text"
                className={`acc-option ${allClosed ? "disabled" : ""}`}
                onClick={allClosed ? null : collapseAllSections}
                aria-label="Close all accordions in the next group"
            >
                Close all
            </Button>
        </div>
    );
};

AccordionExpandCollapse.displayName = "AccordionExpandCollapse";
export { AccordionExpandCollapse };
